import { Themes } from './themes';

export const CurrentDayPartsCopiesThemes = {
  [Themes.DEFAULT]: 'Configure day-parting (optional)',
  [Themes.NBCU]: 'Configure dayparting (optional)'
};
